import type { Component, Article, StoryVignette } from "../types/content";
import type { PlaceholderResource } from "../types/injectables";
import type {
  ClusterOrSingleHeader,
  FeedItem,
} from "../types/content/feedItem";
import type { BoxFooter } from "../types/content/boxFooter";
import type { BoxHeader } from "../types/content/boxHeader";
import type { FeedItemVignette } from "../types/content/feedItemVignette";

const isArticle = (component: Component): component is Article =>
  component.type === "Article";

const isArticleFeedItem = (component: FeedItem) =>
  component.type === "Single" || component.type === "Cluster";

const isBoxFeedItem = (component: FeedItem) => component.type === "Box";

const isFeedItem = (
  component: FeedItem | PlaceholderResource,
): component is FeedItem =>
  component.type === "Single" ||
  component.type === "Cluster" ||
  component.type === "Box";

const isInjectable = (
  component: FeedItem | PlaceholderResource,
): component is PlaceholderResource => component.type === "placeholder";

const isStoryVignette = (
  component: StoryVignette | BoxHeader | BoxFooter,
): component is StoryVignette => component.type === "StoryVignette";

const isFeedItemVignette = (
  component: BoxHeader | BoxFooter | ClusterOrSingleHeader,
): component is FeedItemVignette => component.type === "FeedItemVignette";

export {
  isFeedItem,
  isArticle,
  isBoxFeedItem,
  isInjectable,
  isArticleFeedItem,
  isStoryVignette,
  isFeedItemVignette,
};
